/* Wuschelherz: aus snippets/wh-consent.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    const box = document.getElementById('WhConsent');
    if (!box || window.whConsent) return;
    const steps = [...box.querySelectorAll('.wh-cc__step')];
    const cats = [...box.querySelectorAll('input[data-cat]')];
    let api = null;
    const ready = () => {
      if (window.whConsentReady) return;
      window.whConsentReady = true;
      document.dispatchEvent(new CustomEvent('wh:consent-ready'));
    };
    const step = (n) => steps.forEach((s) => { s.hidden = s.dataset.step !== String(n); });
    const fill = () => {
      // aktuelle Wahl in die Schalter übernehmen (beim erneuten Öffnen)
      const c = api && api.currentVisitorConsent ? api.currentVisitorConsent() : {};
      cats.forEach((i) => { i.checked = c[i.dataset.cat] === 'yes'; });
    };
    const open = (n) => {
      fill(); step(n || 1); box.hidden = false; document.documentElement.classList.add('wh-cc-open');
      const f = box.querySelector('.wh-cc__step:not([hidden]) .wh-cc__btn'); if (f && n) f.focus();
    };
    const close = () => { box.hidden = true; document.documentElement.classList.remove('wh-cc-open'); ready(); };
    const save = (v) => {
      close();
      try { localStorage.setItem('wh-consent-choice', JSON.stringify({ a: v.analytics, m: v.marketing, p: v.preferences, t: Date.now() })); } catch (e) {}
      if (!api) return;
      api.setTrackingConsent({ analytics: v.analytics, marketing: v.marketing, preferences: v.preferences, sale_of_data: v.marketing }, () => {
        document.dispatchEvent(new CustomEvent('wh:consent-saved', { detail: v }));
      });
    };
    box.addEventListener('click', (e) => {
      const b = e.target.closest('[data-cc]'); if (!b) return;
      const a = b.dataset.cc;
      if (a === 'all') save({ analytics: true, marketing: true, preferences: true });
      else if (a === 'none') save({ analytics: false, marketing: false, preferences: false });
      else if (a === 'settings') { step(2); fill(); }
      else if (a === 'back') step(1);
      else if (a === 'save') {
        const v = {}; cats.forEach((i) => { v[i.dataset.cat] = i.checked; }); save(v);
      }
    });
    // „Cookie-Einstellungen“ öffnet den Banner erneut, direkt mit den Kategorien
    document.addEventListener('click', (e) => {
      const t = e.target.closest && e.target.closest('a[href$="#cookie-einstellungen"], [data-wh-consent-open]');
      if (!t) return;
      e.preventDefault(); open(2);
    });
    window.whConsent = { open };
    const start = () => {
      api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api) { ready(); return; }
      if (location.hash === '#cookie-einstellungen') { open(2); return; }
      // shouldShowBanner() meldet nur die Region; offen ist der Banner nur, solange noch keine Wahl getroffen wurde.
      // Ohne erkannte Region (Safari-Tracking-Schutz, Blocker: getRegion() leer, shouldShowBanner() false) trotzdem zeigen,
      // weil wir nur nach Deutschland liefern (Gegenprüfung strategie 2026-10-23). Unentschieden heißt weiter kein Tracking.
      const regionKnown = !!(api.getRegion && api.getRegion());
      const region = (api.shouldShowBanner ? api.shouldShowBanner() : true) || !regionKnown;
      const c = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
      // getTrackingConsent() liefert ohne erkannte Region '' statt 'no_interaction'
      const tc = api.getTrackingConsent ? api.getTrackingConsent() : '';
      const undecided = (!tc || tc === 'no_interaction')
        && !['analytics', 'marketing', 'preferences'].some((k) => c[k] === 'yes' || c[k] === 'no');
      // Rückfall: Kann Shopify die Wahl nicht speichern (Blocker), nicht bei jedem Seitenaufruf neu fragen; Tracking bleibt dann aus
      let local = null; try { local = localStorage.getItem('wh-consent-choice'); } catch (e) {}
      // Hat Shopify die gespeicherte Wahl verloren (Cookie _tracking_consent fehlt, z. B. Safari), die eigene Wahl
      // der Besucherin still erneut übergeben. Es wird nur wiederholt, was sie selbst gewählt hat.
      if (undecided && local) {
        try {
          const w = JSON.parse(local);
          api.setTrackingConsent({ analytics: !!w.a, marketing: !!w.m, preferences: !!w.p, sale_of_data: !!w.m }, () => {});
        } catch (e) {}
      }
      if (region && undecided && !local) open(1); else ready();
    };
    // Ohne Antwort der Bibliothek (Blocker, Fehler) nicht ewig warten: Willkommens-Fenster nach 8 s freigeben
    setTimeout(() => { if (!api) ready(); }, 8000);
    const load = () => {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { ready(); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (err) { ready(); return; } start(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
  })();
